import { iconSize } from '@pkg/primitives';

export const tokens = {
    wrapper: {
        minHeight: iconSize.smaller,
    },
    arrows: {
        count: 3,
    },
    animation: {
        duration: 600,
        delay: 100,
    },
};
